'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;

import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { CrmSuiteTitle } from './CrmSuiteTitle';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CalculatorAnchorLink from '../../common/CalculatorAnchorLink';
import { SuiteTiles } from './SuiteTiles';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import { getSuiteLegalDisclaimerUrl } from 'pricing-pages-lib/utils/urls';
import { useSelector } from 'react-redux';
import { isMon569VariantSelector } from '../../../selectors/ExperimentTreatmentSelectors';
import Mon569SuiteTiles from '../../MON569/Mon569SuiteTiles';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import BannerHierarchySection from '../../banners/BannerHierarchySection';
import { SCREENS } from 'pricing-pages-unified-ui/constants/Tracking';
const SectionContainer = styled(UIFlex).withConfig({
  displayName: "CrmSuiteTopSection__SectionContainer",
  componentId: "smxxpk-0"
})(["position:relative;align-items:", ";", ";"], ({
  isMon569Variant
}) => isMon569Variant ? 'start' : 'center', breakpoint.cs(_t || (_t = _`
    align-items: center;
  `)));
const SubtitleContainer = styled(UIFlex).withConfig({
  displayName: "CrmSuiteTopSection__SubtitleContainer",
  componentId: "smxxpk-1"
})(["margin-bottom:24px;justify-content:center;", ""], breakpoint.tablet(_t2 || (_t2 = _`
    margin: 20px 0;
    justify-content: center;
  `)));
const StyledContainer = styled.div.withConfig({
  displayName: "CrmSuiteTopSection__StyledContainer",
  componentId: "smxxpk-2"
})(["margin:", ";justify-content:center;", ";"], ({
  isMon569Variant
}) => isMon569Variant ? '0' : '0 auto 10px', breakpoint.cs(_t3 || (_t3 = _`
    margin: 0 auto
  `)));
const TitleContainer = styled.div.withConfig({
  displayName: "CrmSuiteTopSection__TitleContainer",
  componentId: "smxxpk-3"
})(["margin:auto 25px;", ";"], breakpoint.tabletPortrait(_t4 || (_t4 = _`
    margin: auto;
    padding: 0 20px;
  `)));
export const SuiteTitleSection = () => {
  const isMon569Variant = useSelector(isMon569VariantSelector);

  const handleLegalLinkClick = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'legal-stuff',
      url: getSuiteLegalDisclaimerUrl(),
      trackingSource: 'crm-suite-page'
    });
  };

  return /*#__PURE__*/_jsxs(TitleContainer, {
    children: [/*#__PURE__*/_jsx(CrmSuiteTitle, {}), /*#__PURE__*/_jsxs(StyledContainer, {
      isMon569Variant: isMon569Variant,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crmSuite.suiteDescription"
      }), /*#__PURE__*/_jsx(UILink, {
        className: "m-left-1",
        external: true,
        href: getSuiteLegalDisclaimerUrl(),
        onClick: handleLegalLinkClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crmSuite.details"
        })
      })]
    }), /*#__PURE__*/_jsxs(SubtitleContainer, {
      children: [/*#__PURE__*/_jsx(UIHelpIcon, {
        className: "m-right-2",
        size: "xxs",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crmSuite.freeUsersTooltip"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crmSuite.unlimitedFreeUsers"
        })
      }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {})]
    })]
  });
};

const CrmSuiteTopSection = ({
  selectedTab
}) => {
  const isMon569Variant = useSelector(isMon569VariantSelector);
  const SuiteTilesComponent = isMon569Variant ? Mon569SuiteTiles : SuiteTiles;
  return /*#__PURE__*/_jsxs(SectionContainer, {
    justify: "center",
    direction: "column",
    isMon569Variant: isMon569Variant,
    children: [!isMon569Variant && /*#__PURE__*/_jsx(SuiteTitleSection, {}), /*#__PURE__*/_jsx("div", {
      style: {
        width: '100%'
      },
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(BannerHierarchySection, {
        screen: SCREENS.GROWTH_SUITE
      })
    }), /*#__PURE__*/_jsx(SuiteTilesComponent, {
      selectedTab: selectedTab
    })]
  });
};

export default CrmSuiteTopSection;